import { render } from "./WaveData.vue?vue&type=template&id=74895726"
import script from "./WaveData.vue?vue&type=script&lang=js"
export * from "./WaveData.vue?vue&type=script&lang=js"

import exportComponent from "C:\\ami-website\\www\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__